/**
 * @module sagas/UserSettings.js
 */
import { all, delay, fork, put, select, take } from 'redux-saga/effects';

import * as Actions from '../actions';
import * as Constants from '../constants';
import { UserAccountActions } from '../constants/UserAccount';
import { tryCall } from '../sagas/Helpers';
import * as ListenerServices from '../services/Listener';
import * as Utils from '../utils';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

function* clearSuccessMessage() {
  yield delay(Constants.UserAccount.CLEAR_SUCCESS_MESSAGE_DELAY);
  yield put(Actions.UserAccount.clearSuccessMessage());
}

export function* watchUpdateAccount() {
  while (LOOP) {
    const action = yield take(UserAccountActions.USER_ACCOUNT_UPDATE_ACCOUNT);
    const values = yield select(Utils.Listener.getUserSettingsFormValues);

    values.newGender = values.newGender === 'NON_BINARY' ? 'NONBINARY' : values.newGender;
    values.currentUsername = yield select(Utils.Listener.getCurrentUsername);
    values.currentPassword = action.payload.currentPassword;
    if (values.newPassword === '') {
      values.newPassword = undefined;
    }
    yield tryCall(ListenerServices.updateAccount, values);
    yield fork(clearSuccessMessage);
  }
}

/**
 * Root UserSettings Saga
 */
export default function* userSettingsSaga() {
  yield all([spawn(watchUpdateAccount)]);
}
